export const AUTH_USER = '[AUTH] user authorized';
export const UNAUTH_USER = '[AUTH] user unauthorized';
export const SET_TOKENS = '[AUTH] set tokens';
export const REMOVE_TOKEN = '[AUTH] token removed';
export const ENABLE_LOADING = '[AUTH] enable loading';
export const DISABLE_LOADING = '[AUTH] disable loading';
export const SUCCESS_MODAL = '[AUTH] success modal';
